export default {"src":"/_next/static/media/search_mika.a42cd312.svg","height":19,"width":19,"blurWidth":0,"blurHeight":0};